<template>
    <div
        v-if="comingEvents.length"
        class="upcoming-events"
    >
        <EventCard
            v-for="event in comingEvents"
            :key="event.id"
            :event="event"
        />
    </div>
</template>

<script setup>
defineProps({
    comingEvents: {
        type: Array,
        default: () => []
    }
});
</script>

<style lang="less">
.upcoming-events {
    display: grid;
    gap: var(--spacing-xs);
    grid-column: 1 / -1;

    .base-card {
        margin-bottom: 1rem;
    }

    span {
        margin-left: var(--spacing-xs);
    }
}

.upcoming-events--grid {
    @media @q-md-min {
        grid-template-columns: repeat(2, 1fr);
        gap: var(--spacing-md);
    }
}
</style>
